import React from "react";
import styled from "styled-components";
import { IconButton, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import FontStyle from "../styles/fontStyles";
import { Help, Info } from "@material-ui/icons";

type TooltipProps = {
  tip: string;
  title: string;
  coordinateStyle: boolean;
};

const TollTipView = styled.div(({ theme, coordinateStyle }) => {
  const { spacing } = theme;
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",

    backgroundColor: "white",
    borderRadius: spacing(0.5),
    boxShadow: "0px 3px 6px #00000029",
    padding: coordinateStyle ? spacing(1.5) : spacing(2.5),
  };
});

const Title = styled.p(({ theme, coordinateStyle }) => {
  const { spacing, palette: colors } = theme;
  return {
    ...FontStyle.bold14,
    marginBottom: coordinateStyle ? 0 : spacing(1.2),
    color: colors.text.secondary,
    marginTop: 0,
  };
});

const Content = styled.p(({ theme }) => {
  const { palette: colors, spacing, breakpoints } = theme;
  return {
    ...FontStyle.medium16,
    color: colors.text.secondary,
    margin: 0,
    maxWidth: spacing(59),
    textAlign: "start",
    marginBottom: spacing(1),
    [breakpoints.down("lg")]: {
      maxWidth: spacing(38),
    },
  };
});

const InfosButton = styled(IconButton)(({ theme }) => {
  const { spacing } = theme;
  return {
    width: spacing(4),
    height: "auto",
    margin: 0,
    padding: 0,
    marginInline: spacing(1),
  };
});

const HelpIcon = styled(Help)(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    width: spacing(2),
    height: "auto",
    color: colors.text.tertiary,
  };
});

const InfoIcon = styled(Info)(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    width: spacing(2),
    height: "auto",
    color: colors.text.primary,
  };
});

const TextOnlyTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "transparent",
    maxWidth: "34.375rem",
  },
})(Tooltip);

const CoordinateTooltip = withStyles({
  tooltip: {
    backgroundColor: "transparent",
    maxWidth: "20rem",
    lineHeight: "20px",
  },
})(Tooltip);

function Tolltip({ tip, title, coordinateStyle }: TooltipProps) {
  return (
    <>
      {coordinateStyle ? (
        <CoordinateTooltip
          title={
            <TollTipView coordinateStyle={coordinateStyle}>
              <Title> </Title>
              <Content>{title}</Content>
            </TollTipView>
          }
        >
          <InfosButton>
            <InfoIcon />
          </InfosButton>
        </CoordinateTooltip>
      ) : (
        <TextOnlyTooltip
          title={
            <TollTipView>
              <Title>{title}</Title>
              <Content>{tip}</Content>
            </TollTipView>
          }
        >
          <InfosButton>
            <HelpIcon />
          </InfosButton>
        </TextOnlyTooltip>
      )}
    </>
  );
}

export default React.memo(Tolltip);
